import {
  CButton,
  CCol,
  CLabel,
  CRow,
  CTextarea,
} from "@coreui/react";
import React, { useCallback, useEffect, useState } from "react";
import Errors, { getFieldErrors } from "../../models/errors";
import { ReceiptItem } from "../../models/receipt";
import CurrencyField from "../currencies/CurrencyField";
import { FieldErrors } from "../form/FieldErrors";
import { emptyValueOnUndefined } from "../../utils/fields";

interface ReceiptItemFormProps {
  item: ReceiptItem;
  currency: string;
  onDelete: (_: ReceiptItem) => void;
  onChange: (_: ReceiptItem) => void;
  errors: Errors;
}

const ReceiptItemForm: React.FC<ReceiptItemFormProps> = ({
  item,
  currency,
  onDelete,
  onChange,
  errors,
}) => {
  const [editingItem, setEditingItem] = useState(item);

  const onDeleteClick = useCallback(() => {
    onDelete(editingItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem]);

  const onDescriptionChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newItem = { ...editingItem };
      newItem.description = e.target.value;
      setEditingItem(newItem);
      onChange(newItem);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editingItem],
  );

  const onAmountChange = useCallback(
    (newAmount?: number) => {
      const newItem = { ...editingItem };
      newItem.amount = newAmount !== undefined ? newAmount : 0;
      setEditingItem(newItem);
      onChange(newItem);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editingItem],
  );

  useEffect(() => {
    setEditingItem(item);
  }, [item]);

  const itemLabelStyle: React.CSSProperties = {
    fontWeight: 600,
    fontSize: "0.8rem",
    color: "var(--theme-muted)",
    marginBottom: "3px",
    display: "block",
  };

  return (
    <div
      style={{
        position: "relative",
        border: "1px solid var(--theme-border)",
        borderLeft: "4px solid #006657",
        borderRadius: "6px",
        marginBottom: "10px",
        padding: "12px 14px 10px",
        background: "var(--theme-surface)",
      }}
    >
      {/* Botón eliminar: siempre arriba a la derecha */}
      <div style={{ position: "absolute", top: "10px", right: "12px" }}>
        <CButton
          color="danger"
          variant="outline"
          size="sm"
          onClick={onDeleteClick}
        >
          <i className="fa fa-trash"></i>
        </CButton>
      </div>

      {/* Fila 1: Detalle | Monto */}
      <CRow className="align-items-end" style={{ paddingRight: "46px" }}>
        <CCol xs={12} md={7}>
          <CLabel style={itemLabelStyle}>
            <span className="text-danger">*</span> Detalle
          </CLabel>
          <CTextarea
            placeholder="Detalle del ítem"
            value={emptyValueOnUndefined(editingItem.description)}
            onChange={onDescriptionChange}
            style={{ resize: "vertical", minHeight: "60px" }}
          />
          <FieldErrors
            errors={getFieldErrors("description", errors) as string[]}
          />
        </CCol>
        <CCol xs={12} md={3}>
          <CLabel style={itemLabelStyle}>
            <span className="text-danger">*</span> Monto
          </CLabel>
          <CurrencyField
            currency={currency}
            placeholder="Monto"
            onChange={onAmountChange}
            value={editingItem.amount}
            limit={1000000000000}
          />
          <FieldErrors
            errors={getFieldErrors("amount", errors) as string[]}
          />
        </CCol>
      </CRow>
    </div>
  );
};

export default ReceiptItemForm;
